export default __webpack_public_path__ + "static/media/misc-makeupA.458a0762.jpg";